




import ServiceSelector from '../composite/ServiceSelector.vue';
import { CreateElement, VNode, VNodeChildren } from 'vue';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component({
  components: { ServiceSelector },
})
export default class ServiceSelectorController extends Vue {
  public availableServices!: string[];
  public selectedService!: string;
  @Prop({default: ''}) protected activeService!: string;

  public data() {
    return {
      selectedService: this.activeService,
      availableServices: ['admin', 'monitoring', 'scan'],
    };
  }

  get serviceOptions() {
    return [this.availableServices.map((item) => ({
      value: item[0].toUpperCase() + item.slice(1),
    }))];
  }

  get getProjectId() {
    return window.location.pathname.slice(window.location.pathname.indexOf('view')+5, -1).split('/')[0];
  }

  @Watch('selectedService')
  public onServiceChanged(val: string, oldVal: string) {
    window.location.href = `/view/${this.getProjectId}/${val.toLowerCase()}`;
  }
}
